import React from 'react';
import { useAppContext } from '../../../../Services/AppContext';
import RootWorkplaceSettingsSlovakia from './Counties/RootWorkplaceSettingsSlovakia';
import useNotification from '../../../../Hooks/useNotification.hook';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	rootWorkplaceId: string;
	onSuccess: () => void;
}

const RootWorkplaceSettings: React.FC<Props> = ({
	rootWorkplaceId,
	onSuccess,
}) => {
	const { globalTemplate } = useAppContext();
	const { showNotificationSuccess } = useNotification();
	const { t } = useTranslation();

	const handleSuccess = () => {
		showNotificationSuccess({
			content: t('base.saved'),
		});
		onSuccess();
	};

	switch (globalTemplate) {
		case 'slovakia':
			return (
				<RootWorkplaceSettingsSlovakia
					rootWorkplaceId={rootWorkplaceId}
					onSuccess={handleSuccess}
				/>
			);
		default:
			return <></>;
	}
};

export default RootWorkplaceSettings;
